<template>
  <div class="required-info">
    <div class="flex flex-column gap-4 pr-2 required-wrapper">
      <div class="flex flex-column gap-2" v-if="shift.associate">
        <h3 class="m-0">Info</h3>
        <shift-view-info :shift="shift" :associate="associate" />
      </div>
      <div class="flex flex-column gap-2">
        <h3 class="m-0">Shift Times</h3>
        <shift-times :shift="shift" />
      </div>
      <div class="flex flex-column gap-2" v-if="shift.signature">
        <h3 class="m-0">Digital Signature</h3>
        <signature :associate="signatureAssociate" key="digitalSignature" :available-signature="shift.signature" />
        <div v-if="shift.explanation" class="flex flex-column gap-1" data-testid="shift-preview-signing-explanation">
          <b>Explanation</b>
          <div class="shift-signing-explanation">{{ shift.explanation }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShiftFormTimes from './form/shift-form-times.vue'
import ShiftViewInfoMain from './info/shift-view-info-main.vue'
import Signature from '@/components/signature.vue'
import util from '@/util'

export default {
  components: {
    'shift-times': ShiftFormTimes,
    'shift-view-info': ShiftViewInfoMain,
    Signature
  },
  props: {
    shift: {
      type: Object,
      default: undefined
    },
    associate: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    signatureAssociate() {
      return {
        name: util.combineAssociateName(this.shift.signature.first_name, this.shift.signature.last_name),
        email: this.shift.signature.email,
        phone: this.shift.signature.phone
      }
    }
  },
  methods: {}
}
</script>

<style scoped>
.required-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  right: -410px;
  background-color: var(--bg-component);
  width: 400px;
  height: fit-content;
  top: 0;
  border-radius: 12px;
  padding: 16px 20px;
}

.shift-signing-explanation {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.required-header {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.required-wrapper {
  max-height: 968px;
  overflow-y: auto;
}

.ant-tag {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
